import { closest, addClass, removeClass } from '@utils/domUtils';
import Validator from './Validator';

/* global FormValidation */

export default function validateBoostChannels(form) {
  return Validator.create(
    form,
    {
      _basket: {
        validators: {
          callback: {
            message: 'Bitte mindestens einen Kanal auswählen.',
            callback: input => {
              const selectedPublishChannels = [
                ...form.querySelectorAll(
                  '.selected-job-boosting-channels [name="publishChannels[]"]',
                ),
              ];

              const valid = selectedPublishChannels.length > 0;

              const errorMessageNode = closest(form, '.form').querySelector(
                '.JobBoostingSelector .error-message-card',
              );

              // TODO: implement this properly!
              const alreadyTriedNextStep = true;

              if (alreadyTriedNextStep) {
                if (valid) {
                  addClass(errorMessageNode, 'hidden-error-message');
                } else {
                  removeClass(errorMessageNode, 'hidden-error-message');
                }
              }

              return valid;
            },
          },
        },
      },
    },
    {
      message: new FormValidation.plugins.Message({
        container: (field, ele) => {
          return closest(ele, '.form').querySelector('.JobBoostingSelector .error-message-wrapper');
        },
      }),
    },
  );
}
